<div class="wrapper wrapper-content mtv-parcels-page row">
    <div class="ibox mainPartPage">
        <div class="ibox-content">
            <report-generator-list  *ngIf="reportGeneratorService.isListShow" class="h-100 d-flex flex-column"></report-generator-list>
            <report-generator-modal *ngIf="reportGeneratorService.isReportModalShow" class="h-100 d-flex flex-column"></report-generator-modal>
        </div>
    </div>
</div>
<runtime-conditions-modal *ngIf="reportGeneratorService.showRuntimeConditionsModal"></runtime-conditions-modal>
<custom-report-view-modal *ngIf="reportGeneratorService.showCustomReportViewModal"></custom-report-view-modal>
<report-name-modal *ngIf="reportGeneratorService.showReportNameModal"></report-name-modal>



// WEBPACK FOOTER //
// /app/src/app/views/report-generator/report-generator.component.html